// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`.replace(/\/+/g, "/");
}

const ROOTS_AUTH = "/auth";
const ROOTS_DASHBOARD = "/";
const ROOTS_APP_INTEGRADOR = "/integrador";
const ROOTS_APP_SOCIAL_MEDIA = "/midias-sociais";
const ROOTS_APP_GESTAO = "/gestao";
const ROOTS_APPS_CONSULTAS = "/consultas";
const ROOTS_APPS_PERFIL_CLICK = "/perfil-click";
const ROOTS_APPS_SITE = "/meu-site";
const ROOTS_APPS_CONCILIADOR = "/conciliador";
const ROOTS_APPS_USUARIOS = "/pagamento";
const ROOTS_APPS_DESIGN = "/design";
const ROOTS_APPS_TRAFEGO = "/trafego";
const ROOTS_APPS_AUTOMACAO = "/automacoes";
const ROOTS_APPS_OPERATIONAL = "/operacional";
const ROOTS_APPS_INTEGRACOES = "/integracoes";
const ROOTS_APPS_LEADS = "/leads";
const ROOTS_APPS_FINANCEIRO = "/financeiro";
const ROOTS_ADMIN = "/admin";
const ROOTS_ADMIN_LEGADO = "/admin-legado";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, "/login"),
  register: path(ROOTS_AUTH, "/register"),
  loginUnprotected: path(ROOTS_AUTH, "/login-unprotected"),
  registerUnprotected: path(ROOTS_AUTH, "/register-unprotected"),
  verify: path(ROOTS_AUTH, "/verify"),
  resetPassword: path(ROOTS_AUTH, "/reset-password"),
  newPassword: path(ROOTS_AUTH, "/new-password"),
};

export const PATH_PAGE = {
  comingSoon: "/coming-soon",
  maintenance: "/maintenance",
  pricing: "/pricing",
  payment: "/payment",
  about: "/about-us",
  contact: "/contact-us",
  faqs: "/faqs",
  page403: "/403",
  page404: "/404",
  page500: "/500",
  components: "/components",
};

export const PATHS = {
  root: ROOTS_DASHBOARD,
  admin: {
    apps: path(ROOTS_ADMIN_LEGADO, "/apps"),
    agenda: path(ROOTS_ADMIN_LEGADO, "/apps/agenda"),
    appsContatos: path(ROOTS_ADMIN_LEGADO, "/apps/contatos"),
    appsContatosNew: path(ROOTS_ADMIN_LEGADO, "/apps/contatos/novo"),
    appsContatosDetail: (publicId: string) =>
      path(ROOTS_ADMIN_LEGADO, `/apps/contatos/${publicId}`),
    task: path(ROOTS_ADMIN, "/task"),
    taskDetail: (publicId: string) => path(ROOTS_ADMIN, `/task/${publicId}`),
    components: {
      root: path(ROOTS_ADMIN_LEGADO, "/apps/components"),
      adminCard: path(ROOTS_ADMIN_LEGADO, "/apps/components/admin-card"),
      adminAppCard: path(ROOTS_ADMIN_LEGADO, "/apps/components/admin-app-card"),
      adminAppCardV2: path(
        ROOTS_ADMIN_LEGADO,
        "/apps/components/admin-app-card-v2",
      ),
      adminMockAvatar: path(
        ROOTS_ADMIN_LEGADO,
        "/apps/components/admin-mock-avatar",
      ),
      adminRichTextEditor: path(
        ROOTS_ADMIN_LEGADO,
        "/apps/components/admin-rich-text-editor",
      ),
      adminTaskCardV2: path(
        ROOTS_ADMIN_LEGADO,
        "/apps/components/admin-task-card-v2",
      ),
      adminTaskDetail: path(
        ROOTS_ADMIN_LEGADO,
        "/apps/components/admin-task-detail",
      ),
      adminDatePicker: path(
        ROOTS_ADMIN_LEGADO,
        "/apps/components/admin-date-picker",
      ),
      adminCatalogCard: path(
        ROOTS_ADMIN_LEGADO,
        "/apps/components/admin-catalog-card",
      ),
    },
    contatos: path(ROOTS_ADMIN, "/contatos"),
    workspace: {
      root: path(ROOTS_ADMIN, "/workspace"),
      detail: (workspaceId: string) =>
        path(ROOTS_ADMIN, `/workspace/${workspaceId}`),
      paidTraffic: {
        root: (workspaceId: string) =>
          path(ROOTS_ADMIN, `/workspace/${workspaceId}/trafego-pago`),
        meta: (workspaceId: string) =>
          path(ROOTS_ADMIN, `/workspace/${workspaceId}/trafego-pago/meta`),
      },
      users: (workspaceId: string) =>
        path(ROOTS_ADMIN, `/workspace/${workspaceId}/users`),
      user: (workspaceId: string, userId: string) =>
        path(ROOTS_ADMIN, `/workspace/${workspaceId}/users/${userId}`),
    },
  },
  workspace: {
    root: "/workspace-legado",
  },
  workspaces: {
    root: "/workspaces",
    myTasks: "/workspaces/minhas-tarefas",
    legado: "/workspaces-legado",
    detail: (teamKey: string) => `/workspaces/${teamKey}`,
    account: "/usuario",
    detailSection: (teamKey: string, section: string) =>
      `/workspaces/${teamKey}?section=${encodeURIComponent(section)}`,
    user: (teamKey: string, userId: string | number) =>
      `/workspaces/${teamKey}/usuarios/${userId}`,
  },
  pedidos: {
    root: "/pedidos",
  },
  user: {
    root: path(ROOTS_DASHBOARD, "user"),
    new: path(ROOTS_DASHBOARD, "user/new"),
    list: path(ROOTS_DASHBOARD, "user/list"),
    cards: path(ROOTS_DASHBOARD, "user/cards"),
    profile: path(ROOTS_DASHBOARD, "user/profile"),
    account: path(ROOTS_DASHBOARD, "user/account"),
    edit: (name: string) => path(ROOTS_DASHBOARD, `user/${name}/edit`),
    demoEdit: path(ROOTS_DASHBOARD, `user/reece-chung/edit`),
  },
  suporte: "https://wa.me/551145212145",
  dashboard: ROOTS_DASHBOARD,
  apps: {
    socialMedias: {
      facebook: {
        root: path(ROOTS_APP_SOCIAL_MEDIA, "/facebook"),
        dashboard: () =>
          path(PATHS.apps.socialMedias.facebook.root, `?step=dashboard`),
        calendar: () =>
          path(PATHS.apps.socialMedias.facebook.root, `?step=calendario`),
        scheduling: () =>
          path(PATHS.apps.socialMedias.facebook.root, `?step=agendamento`),
      },
    },
    integrador: {
      root: path(ROOTS_APP_INTEGRADOR, "/dashboard"),
      tags: {
        root: path(ROOTS_APP_INTEGRADOR, "/tags"),
        edit: (id: string) =>
          path(PATHS.apps.integrador.tags.root, `/${id}/edit`),
        new: () => path(PATHS.apps.integrador.tags.root, `/new`),
      },
      credenciais: {
        root: path(ROOTS_APP_INTEGRADOR, "/credenciais"),
        rootForVendor: (vendorId: string, errorMessage = "") =>
          path(
            ROOTS_APP_INTEGRADOR,
            `/credenciais?vendorId=${vendorId}&errorMessage=${errorMessage}`,
          ),
        edit: (id: string) =>
          path(PATHS.apps.integrador.credenciais.root, `/${id}/edit`),
        new: (vendorId: string, portalId: string) =>
          path(
            PATHS.apps.integrador.credenciais.root,
            `/new?vendorId=${vendorId}&portalId=${portalId}`,
          ),
      },
      estoque: {
        root: path(ROOTS_APP_INTEGRADOR, "/estoque"),
        ativos: path(ROOTS_APP_INTEGRADOR, "/estoque/1"),
        desativados: path(ROOTS_APP_INTEGRADOR, "/estoque/2"),
        new: (type: string | number, condition: string | number) =>
          path(
            PATHS.apps.integrador.estoque.root,
            `/new?vehicleType=${type}&vehicleCondition=${condition}`,
          ),
        edit: ({
          vId,
          isPublished,
          vehicleType,
          hasGestao,
        }: {
          vId: string;
          isPublished: boolean;
          vehicleType: number;
          hasGestao: boolean;
        }) =>
          hasGestao
            ? path(
                PATHS.apps.gestao.estoque.root,
                `/vehicle?isPublished=${isPublished}&step=dados&vehicleType=${vehicleType}&vehicleId=${vId}`,
              )
            : path(
                PATHS.apps.integrador.estoque.root,
                `/${vId}/edit?isPublished=${isPublished}&vehicleType=${vehicleType}`,
              ),
      },
      config: {
        root: path(ROOTS_APP_INTEGRADOR, "/config"),
      },
      aderir: path(ROOTS_APP_INTEGRADOR, "/aderir"),
    },
    gestao: {
      pessoas: {
        root: path(ROOTS_APP_GESTAO, "/pessoas/1"),
        new: path(ROOTS_APP_GESTAO, "/pessoas/new"),
      },
      financeiro: {
        root: path(ROOTS_APP_GESTAO, "/financeiro/movimentacao"),
      },
      estoque: {
        root: path(ROOTS_APP_GESTAO, "/estoque"),
        ativos: path(ROOTS_APP_GESTAO, "/estoque/1"),
        desativados: path(ROOTS_APP_GESTAO, "/estoque/2"),
        vendidos: path(ROOTS_APP_GESTAO, "/estoque/3"),
        transito: path(ROOTS_APP_GESTAO, "/estoque/4"),
        tags: {
          root: path(ROOTS_APP_GESTAO, "/tags"),
          edit: (id: string) =>
            path(PATHS.apps.gestao.estoque.tags.root, `/${id}/edit`),
          new: () => path(PATHS.apps.gestao.estoque.tags.root, `/new`),
        },
        new: () => path(PATHS.apps.gestao.estoque.root, `/vehicle`),
        edit: ({
          vId,
          isPublished,
          vehicleType,
        }: {
          vId: string;
          isPublished: boolean;
          vehicleType: number;
        }) =>
          path(
            PATHS.apps.gestao.estoque.root,
            `/vehicle?isPublished=${isPublished}&step=dados&vehicleType=${vehicleType}&vehicleId=${vId}`,
          ),
      },
      usuarios: {
        root: path(ROOTS_APP_GESTAO, "/usuarios"),
      },
      permissoes: {
        root: path(ROOTS_APP_GESTAO, "/permissoes"),
      },
    },
    consultas: {
      aderir: path(ROOTS_APPS_CONSULTAS, "/aderir"),
      precoVeiculos: path(ROOTS_APPS_CONSULTAS, "/tabela-fipe"),
    },
    perfilClick: {
      root: ROOTS_APPS_PERFIL_CLICK,
    },
    site: {
      gestor: path(ROOTS_APPS_SITE, "/gestor"),
      aderir: path(ROOTS_APPS_SITE, "/aderir"),
      conteudo: path(ROOTS_APPS_SITE, "/conteudo"),
      adminCreate: () => path(PATHS.apps.site.gestor, `/admin-create`),
      adminVendorCreate: () => path(PATHS.apps.site.gestor, `/vendor-create`),
    },
    conciliador: {
      root: ROOTS_APPS_CONCILIADOR,
      edit: (cnpj: string, id: string) =>
        path(ROOTS_APPS_CONCILIADOR, `/${id}/edit?cnpj=${cnpj}`),
      veiculos: path(ROOTS_APPS_CONCILIADOR, "/veiculos"),
      eventos: path(ROOTS_APPS_CONCILIADOR, "/eventos"),
    },
    usuarios: {
      root: path(ROOTS_APPS_USUARIOS, `?step=painel`),
    },
    artes: {
      criar: {
        root: path(ROOTS_APPS_DESIGN, "/artes"),
      },
      orders: {
        root: path(ROOTS_APPS_DESIGN, "/pedidos"),
      },
    },
    trafego: {
      turbinar: {
        root: path(ROOTS_APPS_TRAFEGO, "/turbinar"),
      },
      orders: {
        root: path(ROOTS_APPS_TRAFEGO, "/pedidos"),
      },
    },
    sync: {
      apps: {
        root: path(ROOTS_DASHBOARD, "/apps"),
      },
    },
    automacoes: {
      automatizarPostagens: {
        root: path(ROOTS_APPS_AUTOMACAO, "/automatizar-postagens"),
        editar: (id: number | string) =>
          path(ROOTS_APPS_AUTOMACAO, `/automatizar-postagens/${id}/editar`),
        agenda: path(ROOTS_APPS_AUTOMACAO, "/automatizar-postagens/agenda"),
        configuracoes: path(
          ROOTS_APPS_AUTOMACAO,
          "/automatizar-postagens/configuracoes",
        ),
        loja: path(ROOTS_APPS_AUTOMACAO, "/automatizar-postagens/loja"),
      },
    },
    integracoes: {
      root: path(ROOTS_APPS_INTEGRACOES, "/"),
      insiraSeuEstoque: {
        root: path(ROOTS_APPS_INTEGRACOES, "/insira-seu-estoque"),
      },
    },
    leads: {
      root: path(ROOTS_APPS_LEADS, "/"),
    },
    financeiro: {
      root: ROOTS_APPS_FINANCEIRO,
      pagamentosCarteira: path(ROOTS_APPS_FINANCEIRO, "/pagamentos-e-carteira"),
      planos: path(ROOTS_APPS_FINANCEIRO, "/planos"),
    },
    operational: {
      root: ROOTS_APPS_OPERATIONAL,
      assistantCalls: path(ROOTS_APPS_OPERATIONAL, "/assistente-sync/chamadas"),
      orgs: {
        root: path(ROOTS_APPS_OPERATIONAL, "/orgs"),
        detail: (organizationId: string) =>
          path(ROOTS_APPS_OPERATIONAL, `/orgs/${organizationId}`),
      },
      contacts: {
        root: path(ROOTS_APPS_OPERATIONAL, "/contatos"),
        new: path(ROOTS_APPS_OPERATIONAL, "/contatos/novo"),
        detail: (contactId: string) =>
          path(ROOTS_APPS_OPERATIONAL, `/contatos/${contactId}`),
      },
      pedidos: {
        root: path(ROOTS_APPS_OPERATIONAL, "/pedidos"),
        detail: (teamId: string) =>
          path(ROOTS_APPS_OPERATIONAL, `/pedidos/${teamId}`),
      },
      billing: {
        root: path(ROOTS_APPS_OPERATIONAL, "/billing"),
        detail: (workspaceId: string) =>
          path(ROOTS_APPS_OPERATIONAL, `/billing/${workspaceId}`),
        planos: {
          root: path(ROOTS_APPS_OPERATIONAL, "/billing/planos"),
          new: () => path(ROOTS_APPS_OPERATIONAL, "/billing/planos/novo"),
          edit: (planId: string) =>
            path(ROOTS_APPS_OPERATIONAL, `/billing/planos/${planId}`),
        },
        enrollments: path(ROOTS_APPS_OPERATIONAL, "/billing/enrollments"),
        packageNew: (workspaceId: string) =>
          path(ROOTS_APPS_OPERATIONAL, `/billing/${workspaceId}/pacotes/novo`),
        packageEdit: (workspaceId: string, packageId: string) =>
          path(
            ROOTS_APPS_OPERATIONAL,
            `/billing/${workspaceId}/pacotes/${packageId}`,
          ),
      },
      publications: {
        root: path(ROOTS_APPS_OPERATIONAL, "/publicacoes"),
      },
      redesign: "/redesign",
      teamMilestones: {
        root: path(ROOTS_APPS_OPERATIONAL, "/marcos-do-cliente"),
      },
    },
  },
};

export const PATH_DOCS = "";
